export class Episode {
    id: number = 0;
    name: string = '';
    episodeNumber: number = 0;
    airDate: Date = new Date();
    createdAt: Date = new Date();
    updatedAt: Date = new Date();

    //for frontend use only
    selected: boolean = false

    static mapProperties(item: any): Episode {
        return {
            id: item.id,
            name: item.name?.replace(/ {2,}/g, ' '),
            episodeNumber: item.episode_number,
            airDate: item.air_date,
            createdAt: item.created_at,
            updatedAt: item.updated_at,

            selected: false
        };
    }
}
